import { OrcaApi, PENDING_SIGNUP_STATUS } from '@orca/api';

export async function fetchBrandInvitationStatus(
  email: string
): Promise<PENDING_SIGNUP_STATUS> {
  if (!email) {
    return Promise.resolve(PENDING_SIGNUP_STATUS.notFound);
  }
  // pendingSignup endpoint should be called always when the user is trying to sign up
  // to cover the case of a Brand pending invitation, trying to signup from a normal sign up view
  // 200 - User found - signup_status: pending | registered
  // 404 - User not found
  try {
    const { signup_status } = await OrcaApi.brandUsers.pendingSignup({
      email,
    });
    return signup_status as PENDING_SIGNUP_STATUS;
  } catch (error) {
    return PENDING_SIGNUP_STATUS.notFound;
  }
}
